@if (wifiCustomerSubscriptions.length > 0) {
  <div class="content-container">
    <h4 translate="services.wifi.subscriptions.customerSubscriptions.title"></h4>
    <div class="row row-cols-1 g-4">
      @for (wifiSubscription of wifiCustomerSubscriptions; track wifiSubscription) {
        <div class="col">
          <div class="card">
            <div class="card-body">
              <h5 class="card-title">
                {{getServiceName(wifiSubscription)}}
                @if (wifiSubscription.disabled) {
                  <span class="text-warning" translate="services.wifi.subscriptions.customerSubscriptions.disabled"></span>
                }
              </h5>
              <div class="mb-3 row">
                <div class="col-sm-3" translate="services.wifi.subscriptions.customerSubscriptions.period.label"></div>
                <div class="col-sm-9">
                  {{'common.period.from' | translate}} {{wifiSubscription.startDateTime | date:getDisplayDateFormat()}}<br/>
                  {{'common.period.to' | translate}} {{wifiSubscription.endDateTime | date:getDisplayDateFormat()}}
                </div>
              </div>
              <div class="mb-3 row">
                <div class="col-sm-3" translate="services.wifi.subscriptions.customerSubscriptions.ssid"></div>
                <div class="col-sm-9">{{wifiSubscription.wifiSsid}}</div>
              </div>
              <div class="mb-3 row">
                <div class="col-sm-3" translate="services.wifi.subscriptions.customerSubscriptions.password"></div>
                <div class="col-sm-9">{{wifiSubscription.password}}</div>
              </div>
            </div>
          </div>
        </div>
      }
    </div>
  </div>
}
